import { Wrench, Clock, Zap, Shield } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useFadeUp } from '@/hooks/useFadeUp';

const serviceIcons: Record<string, LucideIcon> = {
  wrench: Wrench,
  clock: Clock,
  zap: Zap,
  shield: Shield,
};

const services = [
  {
    id: 'reparation',
    icon: 'wrench',
    title: 'Réparation de volets roulants',
    description: 'Volet bloqué, cassé ou qui ne fonctionne plus ? Nous diagnostiquons et réparons tous types de pannes : remplacement de moteur, sangle, manivelle, treuil, lames ou tablier. Intervention rapide sur toutes les marques.',
    image: '/images/service-reparation-accueil.webp',
  },
  {
    id: 'depannage',
    icon: 'clock',
    title: 'Dépannage urgent 7j/7',
    description: 'Volet coincé en position ouverte ou fermée ? Nous intervenons dans les plus brefs délais dans tout le Hainaut. Dépannage d\'urgence pour sécuriser votre habitation, avec diagnostic gratuit.',
    image: '/images/service-depannage-accueil.webp',
  },
  {
    id: 'motorisation',
    icon: 'zap',
    title: 'Motorisation de volets',
    description: 'Transformez votre volet manuel en volet électrique. Installation de moteur tubulaire avec télécommande. Confort, sécurité et possibilité de pilotage domotique. Compatible Somfy, Simu, Nice.',
    image: '/images/service-motorisation-accueil.webp',
  },
  {
    id: 'entretien',
    icon: 'shield',
    title: 'Entretien et maintenance',
    description: 'Prolongez la durée de vie de vos volets avec un entretien régulier. Nettoyage, lubrification des mécanismes, vérification des fixations et réglages. Prévention des pannes avant qu\'elles ne surviennent.',
    image: '/images/service-entretien-accueil.webp',
  },
];

export function ServicesSection() {
  const ref = useFadeUp();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div ref={ref} className="fade-up max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="section-title">Nos services</h2>
          <p className="section-subtitle">
            Des solutions adaptées à chaque situation, pour tous types de volets roulants
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {services.map((service) => {
            const Icon = serviceIcons[service.icon];
            return (
              <div key={service.id} className="card group overflow-hidden border border-background-200 p-0">
                <div className="h-48 md:h-56 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    title={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center shrink-0">
                      {Icon && <Icon className="w-5 h-5 text-accent-500" />}
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-700 text-sm md:text-base">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}